import { ConfigProvider, type TractianUITranslations } from '@tractian/ui'
import { enUS } from '@tractian/ui/dist/locales/en-us'
import { ptBR } from '@tractian/ui/dist/locales/pt-br'
import { useTranslation } from 'react-i18next'

const DATE_LOCALES = {
  en: enUS.date,
  'pt-BR': ptBR.date
} as const

function resolveDateLocale(lng: string) {
  if (lng.startsWith('pt')) return DATE_LOCALES['pt-BR']
  return DATE_LOCALES.en
}

export function TractianUIProvider({ children }: { children: React.ReactNode }) {
  const { t, i18n } = useTranslation(['common'])
  const lng = i18n.language

  const tractianUILocaleConfig = {
    lang: {
      common: {
        today: t('common:tractian.common.today'),
        page: t('common:tractian.common.page'),
        about: t('common:tractian.common.about'),
        print: t('common:tractian.common.print'),
        download: t('common:tractian.common.download'),
        openInNewTab: t('common:tractian.common.openInNewTab'),
        close: t('common:tractian.common.close'),
        zoomIn: t('common:tractian.common.zoomIn'),
        zoomOut: t('common:tractian.common.zoomOut'),
        rotateLeft: t('common:tractian.common.rotateLeft'),
        rotateRight: t('common:tractian.common.rotateRight'),
        back: t('common:tractian.common.back'),
        next: t('common:tractian.common.next'),
        image: t('common:tractian.common.image'),
        audio: t('common:tractian.common.audio'),
        video: t('common:tractian.common.video'),
        clear: t('common:tractian.common.clear'),
        save: t('common:tractian.common.save'),
        remove: t('common:tractian.common.remove')
      },
      date: {
        at: t('common:tractian.date.at'),
        for: t('common:tractian.date.for')
      },
      dateTimePicker: {
        empty: t('common:tractian.dateTimePicker.empty')
      },
      dateTimePickerRange: {
        empty: t('common:tractian.dateTimePicker.empty')
      },
      timePickerRange: {
        empty: t('common:tractian.dateTimePicker.empty')
      },
      mediaViewer: {
        unsupportedContent: {
          notSupportedMessage: t(
            'common:tractian.mediaViewer.unsupportedContent.notSupportedMessage'
          ),
          clickText: t('common:tractian.mediaViewer.unsupportedContent.clickText'),
          instructionText: t('common:tractian.mediaViewer.unsupportedContent.instructionText')
        },
        info: {
          title: t('common:tractian.mediaViewer.info.title'),
          fileName: t('common:tractian.mediaViewer.info.fileName'),
          documentType: t('common:tractian.mediaViewer.info.documentType'),
          fileSize: t('common:tractian.mediaViewer.info.fileSize'),
          uploadDate: t('common:tractian.mediaViewer.info.uploadDate'),
          uploadBy: t('common:tractian.mediaViewer.info.uploadBy')
        }
      }
    } satisfies TractianUITranslations,
    date: resolveDateLocale(lng)
  }

  return <ConfigProvider locale={tractianUILocaleConfig}>{children}</ConfigProvider>
}
